import Mould from "../assests/images/mould-damp.webp";
import ActiveLeaks from "../assests/images/water-leakage.webp";
import DefectiveBoiler from "../assests/images/defective-boiler.webp";
import CrumblingPlaster from "../assests/images/crumbling-plaster.webp";
import ElecFaults from "../assests/images/electrical-fault.webp";
import WrongBrickWork from "../assests/images/defective-brickwork.webp";
import BrokenRoofing from "../assests/images/broken-roofing.webp";
import DrainageIssue from "../assests/images/drainage-issues.webp";
import FaultyWindows from "../assests/images/broken-windows.webp";
import RatInfestation from "../assests/images/rat-infestation.webp";
const InjuryClaimData = [
  {
    id: 1,
    title: "Public liability",
    desc: "An accident in that occurs in a public space i.e. tripping over uneven pavement on a public footpath",
    img: Mould,
  },
  {
    id: 2,
    title: "Occupiers liability",
    desc: "An accident in a private space i.e. injuring yourself in a rented property if proper maintenance work has not been carried out",
    img: ActiveLeaks,
  },
  {
    id: 3,
    title: "Employers liability",
    desc: "Employers liability – an accident or illness in the work place i.e. falling from height if proper safety equipment or training was not provided",
    img: DefectiveBoiler,
  },
  {
    id: 4,
    title: "Road traffic accident",
    desc: "An accident that occurs on the road i.e. being knocked off your bicycle by another vehicle",
    img: CrumblingPlaster,
  },
  {
    id: 5,
    title: "Occupiers liability",
    desc: "An accident in a private space i.e. injuring yourself in a rented property if proper maintenance work has not been carried out",
    img: ElecFaults,
  },
  {
    id: 6,
    title: "Employers liability",
    desc: "Employers liability – an accident or illness in the work place i.e. falling from height if proper safety equipment or training was not provided",
    img: WrongBrickWork,
  },
  {
    id: 7,
    title: "Road traffic accident",
    desc: "An accident that occurs on the road i.e. being knocked off your bicycle by another vehicle",
    img: BrokenRoofing,
  },
  {
    id: 8,
    title: "Occupiers liability",
    desc: "An accident in a private space i.e. injuring yourself in a rented property if proper maintenance work has not been carried out",
    img: DrainageIssue,
  },
  {
    id: 9,
    title: "Employers liability",
    desc: "Employers liability – an accident or illness in the work place i.e. falling from height if proper safety equipment or training was not provided",
    img: FaultyWindows,
  },
  {
    id: 10,
    title: "Road traffic accident",
    desc: "An accident that occurs on the road i.e. being knocked off your bicycle by another vehicle",
    img: RatInfestation,
  },
];
export { InjuryClaimData };
